

import axios from 'axios';
import baseConfig from '@/common/baseConfig';
import { CODE } from '@/api/config/xhr';
import { Toast } from 'vant';
import Router from '../router'
const SERVER_BASE_URL = baseConfig.SERVER_BASE_URL;

export default function fetch(options) {
  let headers = {};
  if (options.headers !== undefined) {
    headers = options.headers;
  } else {
    headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Accept-language': 'en-us',
      'Content-Security-Policy': 'upgrade-insecure-requests',
    };
  }
  
  return new Promise((resolve, reject) => {
    const instance = axios.create({
      baseURL: SERVER_BASE_URL,
      timeout: 1005000,
      headers,
    });
    const temp = instance(options);
    temp.then(({ data }) => {
      const code = data.error;
      if (code === CODE.success) {
        resolve(data);
      } else {
        // if (!options.url.includes('enduser/profile')) {
        if (code === 'AuthFailed') {
          sessionStorage.setItem('payload', '');
          // Router.push({name:'index',params:{type:0}})
        } else {
          // if (code !== 'AddressHavingNotCloseAction') {
          //   // Message.error(CODE[code] || code);
          // }
        }
        // }
        reject(data);
        Toast.fail({ message: CODE[code] });
        return Promise.reject(new Error(data.error || 'Error'))
      }
    }).catch((data) => {
      reject(data);
    });
  });
}



// WEBPACK FOOTER //
// ./src/common/fetch.js